<template lang="pug">
    .authentication-form(v-if="! token")
        transition(name="slide-vertical")
            .notification.is-danger.is-light(v-if="error")
                button.delete(type="button" @click="error = false")
                | {{ error }}
        .notification.is-info.is-light(v-if="password.success")
            button.delete(type="button" @click="password.success = false; tab = 'signin'")
            | {{ password.success }}
        validation-observer(v-else v-slot="{ invalid }" ref="form")
            form(@submit.prevent="submit")
                .panel(:class="{ 'no-tabs': ! registration }")
                    loading(:active="loading" :is-full-page="false" :height="40" :width="40" color="#084375")
                    .tabs.is-centered(v-if="registration")
                        ul
                            li(:class="{ 'is-active': tab === 'signin' }")
                                a(@click.prevent="tab = 'signin'") Anmelden
                            li(:class="{ 'is-active': tab === 'register' }")
                                a(@click.prevent="tab = 'register'") Registrieren
                    .box(v-if="tab === 'forgot'")
                        .field
                            validation-provider(name="E-Mail Adresse" rules="required|email" v-slot="{ errors }")
                                label.label(for="email") E-Mail Adresse
                                .control.has-icons-right
                                    input#email.input(
                                        type="email"
                                        name="email"
                                        v-model="form.email"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-envelope
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                    .box(v-if="tab === 'signin'")
                        .field
                            validation-provider(name="E-Mail Adresse" rules="required|email" v-slot="{ errors }")
                                label.label(for="email") E-Mail Adresse
                                .control.has-icons-right
                                    input#email.input(
                                        type="email"
                                        name="email"
                                        v-model="form.email"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-envelope
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                        .field
                            validation-provider(name="Passwort" rules="required" v-slot="{ errors }")
                                label.label(for="password") Passwort
                                .control.has-icons-right
                                    input#password.input(
                                        :type="password.type"
                                        name="password"
                                        v-model="form.password"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    button.icon.is-small.is-right(
                                        v-if="form.password && password.type === 'password'"
                                        type="button" @click="password.type = 'text'"
                                    )
                                        i.far.fa-eye
                                    button.icon.is-small.is-right(
                                        v-else-if="form.password && password.type === 'text'"
                                        type="button" @click="password.type = 'password'"
                                    )
                                        i.far.fa-eye-slash
                                    span.icon.is-small.is-right(v-else)
                                        i.fas.fa-key
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                    .box(v-else-if="tab === 'register'")
                        select-with-validation.select-field(
                            rules="required"
                            name="Anrede"
                            v-model="form.gender"
                            :options="genders"
                            :multiple="false"
                            :searchable="false"
                            :allow-empty="false"
                            :show-labels="true"
                            track-by="value"
                            label="label"
                            placeholder="bitte wählen..."
                            deselect-label="mit Enter abwählen"
                            selected-label="ausgewählt"
                            select-label="mit Enter auswählen"
                        )
                        //- .field
                        //-     label.label Anrede
                        //-     multiselect(
                        //-         v-model="form.gender"
                        //-         name="label"
                        //-         :options="genders"
                        //-         :multiple="false"
                        //-         :searchable="false"
                        //-         :allow-empty="false"
                        //-         :show-labels="true"
                        //-         track-by="value"
                        //-         label="label"
                        //-         placeholder="bitte wählen..."
                        //-         deselect-label="mit Enter abwählen"
                        //-         selected-label="ausgewählt"
                        //-         select-label="mit Enter auswählen"
                        //-         :class="{ 'is-danger': errors && errors.length }"
                        //-     )
                        //-     p.help.has-text-grey Pflicht
                        .field
                            validation-provider(name="Vorname" rules="required" v-slot="{ errors }")
                                label.label(for="first_name") Vorname
                                .control.has-icons-right
                                    input#name.input(
                                        type="text"
                                        name="first_name"
                                        v-model="form.first_name"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-user
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                        .field
                            validation-provider(name="Nachname" rules="required" v-slot="{ errors }")
                                label.label(for="last_name") Nachname
                                .control.has-icons-right
                                    input#name.input(
                                        type="text"
                                        name="last_name"
                                        v-model="form.last_name"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-user
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                        .field
                            label.label(for="company") Firma
                            .control.has-icons-right
                                input#company.input(type="text" name="company" v-model="form.company")
                                span.icon.is-small.is-right
                                    i.fas.fa-city
                        .field
                            validation-provider(name="E-Mail Adresse" rules="required|email" v-slot="{ errors }")
                                label.label(for="email") E-Mail Adresse
                                .control.has-icons-right
                                    input#email.input(
                                        type="email"
                                        name="email"
                                        v-model="form.email"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    span.icon.is-small.is-right
                                        i.fas.fa-envelope
                                p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                        .field
                            validation-provider(name="Passwort" rules="required|password:@score" v-slot="{ errors }")
                                label.label(for="password") Passwort
                                .control.has-icons-right
                                    input#password.input(
                                        :type="password.type"
                                        name="password"
                                        v-model="form.password"
                                        :class="{ 'is-danger': errors && errors.length }"
                                    )
                                    button.icon.is-small.is-right(
                                        v-if="form.password && password.type === 'password'"
                                        type="button" @click="password.type = 'text'"
                                    )
                                        i.far.fa-eye
                                    button.icon.is-small.is-right(
                                        v-else-if="form.password && password.type === 'text'"
                                        type="button" @click="password.type = 'password'"
                                    )
                                        i.far.fa-eye-slash
                                    span.icon.is-small.is-right(v-else)
                                        i.fas.fa-key
                                password(
                                    v-model="form.password"
                                    :strength-meter-only="true"
                                    @score="score => password.score = score"
                                    @feedback="passwordFeedback"
                                )
                                p.help.is-danger(v-if="password.warning || (errors && errors.length)") {{ password.warning || errors[0] }}
                                p.help.has-text-grey(v-else) Pflicht
                            validation-provider(name="score")
                                input#password-score(type="hidden" name="password-score" v-model.number="password.score")
                    .buttons.is-pulled-left(v-if="tab === 'signin'")
                        button.button.is-light(type="button" @click="tab = 'forgot'") Ich habe mein Passwort vergessen
                    .buttons.is-pulled-left(v-else-if="tab === 'forgot'")
                        button.button.is-light(type="button" @click="tab = 'signin'") Abbrechen
                    .buttons.is-pulled-right
                        .control
                            button.button.is-primary(v-if="tab === 'signin'" type="submit" :disabled="invalid") {{ signinButtonText }}
                            button.button.is-primary(v-else-if="tab === 'register'" type="submit" :disabled="invalid") {{ registerButtonText }}
                            button.button.is-primary(v-else-if="tab === 'forgot'" type="submit" :disabled="invalid") Passwort zurücksetzen Link senden
                    .is-clearfix
    .member(v-else)
        slot
</template>

<script>

import _ from 'lodash'

import Vue from 'vue'
import store from '@/store'

import { mapGetters } from 'vuex'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import Password from 'vue-password-strength-meter'
import Loading from 'vue-loading-overlay'

import { translateWarnings, translateSuggestion } from '@/validation';
import SelectWithValidation from '@/components/Partials/SelectWithValidation'

let timeout;
export default {
    name: 'Authenticate',
    props: {
        registration: {
            type: Boolean,
            default: true,
        },
        defaultTab: {
            type: String,
            default: 'signin', // [ signin | register ]
        },
        signinButtonText: {
            type: String,
            default: 'Anmelden',
        },
        registerButtonText: {
            type: String,
            default: 'Registrieren',
        },
    },
    data() {
        let data = {
            error: false,
            loading: false,
            activeTab: this.defaultTab,
            form: {
                gender: undefined,
                first_name: '',
                last_name: '',
                company: '',
                email: '',
                password: '',
            },
            password: {
                type: 'password',
                score: 0,
                warning: false,
                success: false,
                suggestions: [],
            },
            genders: [
                {
                    value: 'M',
                    label: 'Herr',
                },
                {
                    value: 'F',
                    label: 'Frau',
                },
                {
                    value: 'X',
                    label: 'Divers',
                }
            ]
        }

        return data
    },
    components: {
        Loading,
        Password,
        ValidationObserver,
        ValidationProvider,
        SelectWithValidation,
    },
    computed: {
        tab: {
            get() {
                let tab = this.activeTab
                if (! this.registration && this.activeTab === 'register') tab = 'signin'

                return tab
            },
            set(value) {
                this.activeTab = value
            }
        },
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            token: 'auth/token',
            cms: 'CMS',
        }),
    },
    methods: {
        async submit() {
            this.error = false
            this.loading = true
            if (timeout) clearTimeout(timeout)

            const valid = await this.$refs.form.validate()
            if (valid && this.recaptchaSiteKey) {
                await this.$recaptchaLoaded()
                try {
                    const token = await this.$recaptcha('auth')

                    switch (this.tab) {
                        case 'signin':
                            store.dispatch('auth/signin', { email: this.form.email, password: this.form.password })
                                .then(data => {
                                    this.$emit('authenticated', data)
                                    this.$emit('success', data)
                                    this.resetForm()
                                })
                                .catch(error => {
                                    const message = _.get(error, 'response.data.debugMessage')
                                    if (message === 'email not verified') {
                                        this.error = 'Diese E-Mail wurde noch nicht verifiziert. Bitte prüfen Sie Ihren Posteingang und bestätigen Sie Ihre E-Mail Adresse.';
                                    } else if (message === 'credentials invalid') {
                                        this.error = 'Es gibt ein Problem mit Ihren Zugangsdaten. Bitte überprüfen Sie Ihre Angeben.';
                                        this.form.password = ''
                                    } else {
                                        this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                                    }
                                    timeout = setTimeout(() => this.error = false, 6000)
                                    this.$emit('authentication-failed')
                                    this.$emit('error')
                                })
                                .finally(() => {
                                    this.loading = false
                                })
                            break;
                        case 'register':
                            let member = _.cloneDeep(this.form)
                            member.gender = this.form.gender.value
                            member.cms_id = this.cms.id
                            store.dispatch('auth/register', member)
                                .then(data => {
                                    this.$emit('registered', data)
                                    this.$emit('success', data)
                                    this.resetForm()
                                })
                                .catch(error => {
                                    console.error(error)

                                    const emailError = _.get(error, 'response.data.errors.email')
                                    if (emailError) {
                                        this.error = 'Diese E-Mail Adresse ist bereits vergeben. Möchten Sie sich einloggen?';
                                        this.activeTab = 'signin'
                                    } else {
                                        this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                                    }
                                    timeout = setTimeout(() => this.error = false, 6000)
                                    this.$emit('registration-failed')
                                    this.$emit('error')
                                })
                                .finally(() => {
                                    this.loading = false
                                })
                            break;
                        case 'forgot':
                            store.dispatch('auth/sendResetLinkEmail', { email: this.form.email, cms_id: parseInt(this.cms.id) })
                                .then(data => {
                                    this.$emit('password-reset-email-sent')
                                    this.resetForm()
                                    this.password.success = 'Sie erhalten in Kürze eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts'
                                })
                                .catch(error => {
                                    console.error(error)

                                    this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                                    timeout = setTimeout(() => this.error = false, 6000)
                                    this.$emit('password-reset-email-failed')
                                    this.$emit('error')
                                })
                                .finally(() => {
                                    this.loading = false
                                })
                            break;
                        default:
                            this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                            timeout = setTimeout(() => this.error = false, 6000)
                            this.loading = false
                            break;

                    }
                } catch (error) {
                    console.error(error);
                    this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                    timeout = setTimeout(() => this.error = false, 6000)
                    this.loading = false
                }
            } else {
                // TODO
                // submit without recaptcha ?

                this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                this.loading = false
                timeout = setTimeout(() => this.error = false, 6000)
            }
        },
        resetForm() {
            this.form = {
                gender: undefined,
                name: '',
                company: '',
                email: '',
                password: '',
            }
        },
        passwordFeedback(feedback) {
            // translateSuggestion
            this.password.warning = translateWarnings(feedback.warning)
        }
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, { siteKey: this.recaptchaSiteKey })
        }
    }
}

</script>

<style lang="sass" scoped></style>
